<template>
    <div>

        <!-- Table -->

        <div class="table-responsive">
            <table class="table trax-simple-table mb-0 certificate" width="100%" style="width:100%">
                <tbody>
                    <tr>
                        <td class="font-weight-bold">
                            {{ lang.polaris.dashboard.certificate }}
                        </td>
                        <td class="text-right">

                            <button type="button" class="btn btn-white btn-sm ml-1 ajax-button"
                                @click="generateCertificate()" :disabled="taskActive"
                                v-if="exportPermission"
                            >
                                {{ lang.polaris.dashboard.generate }} PDF
                                <br><small>{{ certificateTimestamp }}</small>
                            </button>

                            <button type="button" class="btn btn-primary btn-sm ml-1"
                                @click="openCertificate()" :disabled="!certificateAvailable || taskActive"
                            >
                                {{ lang.polaris.dashboard.download }} PDF
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <trax-ui-simple-table
            :id="id" :header="0" :rows="rows" :cols="cols" :bus="bus">
        </trax-ui-simple-table>

        <!-- ZIP file: packages what is already on the disk -->

        <div class="table-responsive" v-if="fullPermission">
            <table class="table trax-simple-table mb-0" width="100%" style="width:100%">
                <tbody>
                    <tr>
                        <td class="font-weight-bold">
                            {{ lang.polaris.dashboard.zip_file }}
                        </td>
                        <td class="text-right">

                            <button type="button" class="btn btn-white btn-sm ml-1"
                                @click="generateArchive()" :disabled="taskActive"
                                v-if="exportPermission"
                            >
                                {{ lang.polaris.dashboard.generate }} ZIP
                                <br v-if="archiveItem"><small v-if="archiveItem">{{ compactTimestamp(archiveItem.updated_at) }}</small>
                            </button>

                            <button type="button" class="btn btn-primary btn-sm ml-1"
                                @click="downloadArchive()" :disabled="!archiveItem || taskActive"
                            >
                                {{ lang.polaris.dashboard.download }} ZIP
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Full generation: rebuilds every file above -->

        <div class="trax-card-footer-row" v-if="fullPermission && exportPermission">
            <div class="table-responsive">
            <table class="table trax-simple-table mb-0" width="100%" style="width:100%">
                <tbody>
                    <tr>
                        <td class="font-weight-bold">
                            {{ lang.polaris.dashboard.full_generation }}
                            <br v-if="taskLabel">
                            <small v-if="taskLabel" :class="taskFailed ? 'text-danger' : 'text-dark'">
                                {{ taskLabel }}
                            </small>
                        </td>
                        <td class="text-right">

                            <button type="button" class="btn btn-default btn-sm ml-1"
                                @click="openGenerateAll()" :disabled="taskActive"
                            >
                                <i class="material-icons trax-spin" v-if="taskActive">autorenew</i>
                                {{ lang.polaris.dashboard.generate_all }}
                            </button>

                            <button type="button" class="btn btn-white btn-sm ml-1"
                                @click="cancelGenerateAll()" v-if="taskActive"
                            >
                                {{ lang.polaris.tasks.cancel }}
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            </div>
        </div>

        <!-- Certificate form modal -->

        <trax-ui-modal-default :id="id+'-certificate-edit'" :bus="bus">
            <enac-atpl-dashboard-export-learner-certificate-form :id="id+'-certificate-edit'" :toastr-id="id+'-toastr'" :bus="bus"
                :learner="learner" :registration="registration"
            >
            </enac-atpl-dashboard-export-learner-certificate-form>
        </trax-ui-modal-default>

        <!-- Full generation modal: the certificate settings are needed, plus the lane -->

        <trax-ui-modal-default :id="id+'-generate-all'" :bus="bus" :title="lang.polaris.dashboard.full_generation_settings">

            <enac-atpl-dashboard-export-learner-certificate-form :id="id+'-generate-all'" :toastr-id="id+'-toastr'" :bus="bus"
                :learner="learner" :registration="registration"
                :submit-label="lang.polaris.dashboard.generate_all"
            >
                <div slot="options" class="text-right mt-4">
                    <trax-ui-checkbox :text="lang.polaris.tasks.night_run" v-model="atNight"></trax-ui-checkbox>
                </div>
            </enac-atpl-dashboard-export-learner-certificate-form>
        </trax-ui-modal-default>

        <!-- Toastr -->

        <trax-ui-toastr :id="id+'-toastr'" :bus="bus" passed-label="1" no-progress="1">
        </trax-ui-toastr>

    </div>
</template>

<script>
    export default {
    
        props: {
            id: { default: 'enac-atpl-dashboard-registration-program' }
        },

        data: function() {
            return {
                lang: lang,
                user: user,
                app_url: app_url,
                learner: data.learner,
                registration: data.registration,
                archiveItem: null,
                task: null,
                timer: null,
                atNight: true,
                cols: [
                    {class: 'font-weight-bold'},
                    {class: 'text-right'},
                ],
                rows: [],
                certificateTimestamp: '',
                certificateMode: null,
                bus: this.$bus
            }
        },

        computed: {

            certificateAvailable() {
                return this.certificateTimestamp != ''
            },

            exportPermission() {
                return this.user.admin || this.user.permissions['export.generate'];
            },

            fullPermission() {
                return this.user.admin || this.user.permissions['export.access-zip-file'];
            },

            // The generation is planned or under way.
            taskActive() {
                if (!this.task) return false;
                return ['pending', 'running', 'cancelling'].indexOf(this.task.status) >= 0;
            },

            taskFailed() {
                return this.task && this.task.status == 'failed';
            },

            taskLabel() {
                if (!this.task) return '';
                if (!this.taskActive && !this.taskFailed) return '';

                var label = this.lang.polaris.tasks[this.task.status];
                if (this.task.status == 'running' && this.task.progress_total) {
                    label += ' ' + this.task.progress + '/' + this.task.progress_total;
                }
                if (this.task.status == 'pending' && this.task.lane == 'night') {
                    label += ' (' + this.lang.polaris.tasks.night_run + ')';
                }
                return label;
            },

            endpoint() {
                return this.app_url+'polaris/api/front/export/learners/'+this.learner.id
                    +'/registrations/'+this.registration.id;
            }
        },

        created() {
            this.bus.$on(this.id+'-states', this.initRows);
            this.bus.$on(this.id+'-certificate-edit-updated', this.certificateUpdated);
            this.bus.$on(this.id+'-generate-all-updated', this.generateAll);
            this.getTask();
        },

        beforeDestroy() {
            this.stopPolling();
        },

        mounted: function() {
            var that = this;
            $('body').on("click", "#"+this.id+"-table button.ajax-button", function() {
                var endpoint = $(this).data('endpoint');
                that.bus.$emit('loader-start-loading');
                axios.post(endpoint)
                    .then(function (response) {
                        that.initRows(response.data.data);
                        that.bus.$emit('loader-stop-loading');
                    })
                    .catch(function (error) {
                        that.bus.$emit('loader-stop-loading');
                    });
            });
        },

        methods: {

            generateCertificate() {
                this.bus.$emit(this.id+'-certificate-edit-open', {title: 'Certificate Settings'})
            },
        
            openCertificate() {
                window.open(
                    this.app_url+'polaris/api/front/export/learners/'+this.learner.id+'/registrations/'+this.registration.id+'/certificate/file'
                );
            },

            certificateUpdated(event) {
                var that = this
                var endpoint = this.app_url+'polaris/api/front/export/learners/'+this.learner.id+'/registrations/'+this.registration.id+'/certificate/generate';
                this.$bus.$emit('loader-start-loading');
                axios.post(endpoint)
                    .then(function (response) {
                        that.initRows(response.data.data);
                        that.$bus.$emit('loader-stop-loading');
                    })
                    .catch(function (error) {
                        that.$bus.$emit('loader-stop-loading');
                    });
            },

            initRows(items) {
                this.rows = [];

                // Keep the last items of each category.
                var competencies;
                var flightHours;
                var archive;
                for (var index in items) {
                    var item = items[index];
                    if (item.type == 'competencies') competencies = item;
                    if (item.type == 'flight_hours') flightHours = item;
                    if (item.type == 'archive') archive = item;
                    if (item.type == 'certificate') {
                        if (item.version > 0) {
                            this.certificateTimestamp = this.compactTimestamp(item.updated_at)
                        }

                        // Both modals edit the same settings.
                        this.bus.$emit(this.id + '-certificate-edit-data', item)
                        this.bus.$emit(this.id + '-generate-all-data', item)
                    }
                }

                // Competencies
                this.rows.push([
                    this.lang.polaris.training.competencies,
                    this.generateCompetencies(competencies) + this.downloadCompetencies(competencies),
                ]);

                // Flight Hours
                this.rows.push([
                    this.lang.polaris.dashboard.flight_hours,
                    this.refreshFlightHours(flightHours) + this.generateFlightHours(flightHours) + this.downloadFlightHours(flightHours),
                ]);

                // Progress File: its row has its own markup, because it carries the state of the
                // generation task and a table filled with HTML strings cannot be reactive.
                this.archiveItem = archive;
            },

            generateCompetencies(item) {
                if (!this.exportPermission) return '';
                var endpoint = this.app_url+'polaris/api/front/export/learners/'+this.learner.id+'/registrations/'+this.registration.id+'/competencies/generate';
                var html = '<button type="button" data-endpoint="'+endpoint+'" '+this.busyAttr()+' class="btn btn-white btn-sm ml-1 ajax-button">';
                html += lang.polaris.dashboard.generate + ' PDF';
                if (item) html += '<br><small>' + this.compactTimestamp(item.updated_at) + '</small>';
                html += '</button>';
                return html;
            },
        
            downloadCompetencies(item) {
                var href = this.app_url+'polaris/api/front/export/learners/'+this.learner.id+'/registrations/'+this.registration.id+'/competencies/file';
                var disabled = item && !this.taskActive ? '' : 'disabled';
                var html = '<button type="button" onclick="window.open(\''+href+'\')" '+disabled+' class="btn btn-primary btn-sm ml-1">';
                html += lang.polaris.dashboard.download + ' PDF';
                html += '</button>';
                return html;
            },


            refreshFlightHours(item) {
                var endpoint = this.app_url+'polaris/api/front/export/learners/'+this.learner.id+'/registrations/'+this.registration.id+'/flight-hours/refresh';
                var html = '<button type="button" data-endpoint="'+endpoint+'" '+this.busyAttr()+' class="btn btn-white btn-sm ml-1 ajax-button">';
                html += 'Refresh';
                html += '</button>';
                return html;
            },

            generateFlightHours(item) {
                if (!this.exportPermission) return '';
                var endpoint = this.app_url+'polaris/api/front/export/learners/'+this.learner.id+'/registrations/'+this.registration.id+'/flight-hours/generate';
                var html = '<button type="button" data-endpoint="'+endpoint+'" '+this.busyAttr()+' class="btn btn-white btn-sm ml-1 ajax-button">';
                html += lang.polaris.dashboard.generate + ' CSV';
                if (item) html += '<br><small>' + this.compactTimestamp(item.updated_at) + '</small>';
                html += '</button>';
                return html;
            },

            // Zips what is already on the disk, right away. Rebuilding the files themselves is what
            // the full generation does, as a task.
            generateArchive() {
                var that = this;
                this.bus.$emit('loader-start-loading');
                axios.post(this.endpoint+'/archive')
                    .then(function (response) {
                        that.initRows(response.data.data);
                        that.bus.$emit('loader-stop-loading');
                    })
                    .catch(function (error) {
                        that.bus.$emit('loader-stop-loading');
                    });
            },

            downloadFlightHours(item) {
                var href = this.app_url+'polaris/api/front/export/learners/'+this.learner.id+'/registrations/'+this.registration.id+'/flight-hours/file';
                var disabled = item && !this.taskActive ? '' : 'disabled';
                var html = '<button type="button" onclick="window.open(\''+href+'\')" '+disabled+' class="btn btn-primary btn-sm ml-1">';
                html += lang.polaris.dashboard.download + ' CSV';
                html += '</button>';
                return html;
            },

            downloadArchive() {
                window.open(this.endpoint+'/archive/file');
            },

            openGenerateAll() {
                this.bus.$emit(this.id+'-generate-all-open');
            },

            // The certificate settings have just been recorded by the modal form: all that is left
            // is to queue the generation. There is no blocking loader, it runs in the background.
            generateAll() {
                var that = this;
                axios.post(this.endpoint+'/full-generation', {lane: this.atNight ? 'night' : 'now'})
                    .then(function (response) {
                        that.setState(response.data);
                    })
                    .catch(function (error) {
                        var message = error.response && error.response.data ? error.response.data.message : undefined;
                        that.bus.$emit(that.id+'-toastr-error', message);
                    });
            },

            cancelGenerateAll() {
                var that = this;
                axios.post(this.endpoint+'/full-generation/cancel')
                    .then(function (response) {
                        that.setState(response.data);
                    })
                    .catch(function (error) {
                    });
            },

            getTask() {
                var that = this;
                axios.get(this.endpoint+'/full-generation/task')
                    .then(function (response) {
                        that.setState(response.data);
                    })
                    .catch(function (error) {
                    });
            },

            // The state always comes from the server, so that a reload shows a queued or running
            // generation whoever started it.
            setState(payload) {
                this.initRows(payload.data);
                this.task = payload.generation_task;

                // The whole card is being rewritten: the other screens must not offer their own
                // buttons meanwhile.
                this.bus.$emit(this.id+'-generation-active', this.taskActive);

                if (this.taskActive) {
                    this.startPolling();
                } else {
                    this.stopPolling();
                }
            },

            startPolling() {
                if (this.timer) return;
                var that = this;
                this.timer = setInterval(function() {
                    axios.get(that.endpoint+'/full-generation/task')
                        .then(function (response) {
                            that.setState(response.data);
                        })
                        .catch(function (error) {
                            that.stopPolling();
                        });
                }, 3000);
            },

            stopPolling() {
                if (!this.timer) return;
                clearInterval(this.timer);
                this.timer = null;
            },

            // The rows of the simple table are HTML strings: this is how they get disabled while
            // the full generation rewrites the very files they act on.
            busyAttr() {
                return this.taskActive ? 'disabled' : '';
            },

            compactTimestamp(timestamp) {
                return moment(timestamp).format('DD/MM/YYYY H:mm:ss');
            }
        }
    }
</script>

<style scoped>

    table.certificate {
        border-bottom: 1px solid #ddd
    }

    table.competencies {
        border-bottom: 1px solid #ddd
    }
</style>
